import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CheckoutContext } from '../../contexts/CheckoutContext';
import { formatUrl } from '../../utils/format';
import CheckoutForm from './CheckoutForm';

const CheckoutComponent = () => {
  const { id } = useParams<{ id: string }>();

  const { firstPayment, offer } = useContext(CheckoutContext);

  useEffect(() => {
    if (offer?.product.name) {
      document.title = offer?.product.name;
    }
  }, [offer]);

  if (firstPayment?.status === 'paid') {
    if (offer?.product?.upsell && offer?.product?.upsellPage) {
      window.location.href = formatUrl(offer.product?.upsellPage, {
        payment_version: 'caktopay',
        amount: String(firstPayment?.amount),
        order_code: id || ''
      });

      return <></>;
    }
  }

  return (
    <>
      <CheckoutForm />
    </>
  );
};

export default CheckoutComponent;
